import React from "react";
import { Card, CardBody, Col, Container, Row } from "reactstrap";

import "leaflet/dist/leaflet.css";
import { TitleBar } from "../../Components/Common/TitleBar/titleBar";

import CountUp from "react-countup";
import { RealTimeMap } from "./RealTimeMap";
import { RealTimeList } from "./RealTimeList";
import { fetchTripDashboard } from "../../slices/thunks";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useRef } from "react";
import { getAllTripsRealTimeList } from "../../slices/realTimeTripDetail/thunk";

const DashboardAnalytics = () => {
  document.title = "Dashboard | D&A - Admin";
  const dispatch = useDispatch();
  const mapRef = useRef(null);

  const realTimeTripList = useSelector((state) => state.RealTimeTrip.tripList);

  useEffect(() => {
    try {
      dispatch(getAllTripsRealTimeList());
    } catch (error) { }

    try {
      const interval = setInterval(() => {
        dispatch(getAllTripsRealTimeList());
      }, 60000);
      return () => clearInterval(interval);
    } catch (error) {

    }
  }, [dispatch]);

  const filteredTrips = realTimeTripList
    .filter((trip) => trip.driver && trip.driver.trim() !== "")
    .slice(0, 10);
  const dashboard = useSelector((state) => state.TripDashboard);
  const loading = useSelector((state) => state.TripDashboard.loading);

  const dashboardCards = [
    {
      title: "Total Trip",
      count: parseFloat(dashboard.totalTrips) || 0,
      percent: parseFloat(dashboard.totalTripsInPerntage) || 0,
      trend: dashboard.trendInTotalTrips || "up",
    },
    {
      title: "Ongoing Trips",
      count: parseFloat(dashboard.ongoingTrips) || 0,
      percent: parseFloat(dashboard.ongoingTripsInPerntage) || 0,
      trend: dashboard.trendInOngoingTrips || "up",
    },
    {
      title: "Successful Trips",
      count: parseFloat(dashboard.successfulTrips) || 0,
      percent: parseFloat(dashboard.successfulTripsInPerntage) || 0,
      trend: dashboard.trendInSuccessfulTrips || "up",
    },
    {
      title: "Cancelled Trips",
      count: parseFloat(dashboard.cancelledTrips) || 0,
      percent: parseFloat(dashboard.cancelledTripsInPerntage) || 0,
      trend: dashboard.trendInCancelledTrips || "up",
    },
  ];

  const focusOnMarker = (lat, lng) => {
    const map = mapRef.current;
    if (map) {
      map.flyTo([lat, lng], 16, { duration: 1.5 });
    }
  };

  useEffect(() => {
    try {
      dispatch(fetchTripDashboard());
    } catch (error) { }
  }, [dispatch]);
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <div className="d-flex flex-column gap-2 gap-sm-3">
            <TitleBar title="Dashboard" />

            <div className="dashbaord-card-container">
              {dashboardCards.map((element, index) => {
                return (
                  <Card key={index} className="card-animate dashboardCard mb-0">
                    <CardBody>
                      <div className="d-flex flex-column flex-sm-row justify-content-between">
                        <div>
                          <p className="mb-0 dashboardCardTitle">
                            {element.title}
                          </p>
                          <h2 className="mt-3 ff-secondary fw-semibold dashboardCardCount">
                            <span className="counter-value">
                              <CountUp
                                start={0}
                                end={element.count}
                                duration={4}
                              />
                            </span>
                          </h2>

                          {element.trend === "up" ? (
                            <p className="mb-0 d-flex flex-wrap align-items-center gap-1">
                              <span className="badge bg-light text-success">
                                <i className="ri-arrow-up-line align-middle"></i>{" "}
                                {element.percent} %
                              </span>
                              <span className="dashboardCardDescription">
                                vs. previous month
                              </span>
                            </p>
                          ) : (
                            <p className="mb-0 d-flex flex-wrap align-items-center gap-1">
                              <span className="badge bg-light text-danger">
                                <i className="ri-arrow-down-line align-middle"></i>{" "}
                                {element.percent} %
                              </span>
                              <span className="dashboardCardDescription">
                                vs. previous month
                              </span>
                            </p>
                          )}
                        </div>
                      </div>
                    </CardBody>
                  </Card>
                );
              })}
            </div>
            <TitleBar title="Real time trip" />
            <div
              className="real-time-container"
              style={{ height: "auto", width: "100%" }}
            >
              <Row className="flex-column flex-xl-row h-100">
                {/* Map first on mobile, second on desktop */}
                <Col
                  xs={12}
                  xl={9}
                  className="order-1 order-xl-2 mb-3 mb-xl-0"
                  style={{
                    minHeight: 300,
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <RealTimeMap
                    data={filteredTrips}
                    mapRef={mapRef}
                    focusOnMarker={focusOnMarker}
                  />
                </Col>

                {/* Table second on mobile, first on desktop */}
                <Col
                  xs={12}
                  xl={3}
                  className="order-2 order-xl-1"
                  style={{
                    minHeight: 300,
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <RealTimeList
                    tripData={filteredTrips}
                    focusOnMarker={focusOnMarker}
                    loading={loading}
                  />
                </Col>
              </Row>
            </div>
          </div>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default DashboardAnalytics;
